import Image from 'next/image';

import useUserContext from '@/hooks/useUserContext';
import { cn } from '@/lib/utils';
import defaultAvatar from '../../../public/admin/default-avatar.png';

export default function UserAvatarRoot() {
  const { user, userGrant } = useUserContext();

  // `media` is an empty array when the image carries no filter
  const avatar = typeof user.media === 'string' && user.media ? user.media : null;

  return (
    <Image
      alt="avatar"
      src={avatar ?? defaultAvatar}
      width={40}
      height={40}
      unoptimized={!!avatar}
      className={cn(
        '!w-10 !h-[40px] object-cover rounded-[50%] inline-block align-middle',
        {
          'border-2 border-error-primary': userGrant && userGrant === 'admin',
        },
      )}
    />
  );
}
